/* eslint-disable require-jsdoc */
import { connect } from 'react-redux';
import EnquiryForm from './newsletter-signup';
import {
    resetFormAction,
    setFormFieldValueAction,
    submitFormAction,
    touchedFormFieldAction
} from 'app/ducks/newsletter-signup';
import {
    selectError,
    selectFieldTouched,
    selectFieldValue,
    selectIsBusy,
    selectSubmittedSuccessfully,
} from 'app/selectors/newsletter-signup';

function mapStateToProps(state) {
    return {
        getFieldTouched: (fieldName) => selectFieldTouched(state, fieldName),
        getFieldValue: (fieldName) => selectFieldValue(state, fieldName),
        isBusy: selectIsBusy(state),
        submittedSuccessfully: selectSubmittedSuccessfully(state),
        error: selectError(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        resetForm: () => dispatch(resetFormAction()),
        setFieldValue: (fieldName, value) => dispatch(setFormFieldValueAction(fieldName, value)),
        touchedField: (fieldName) => dispatch(touchedFormFieldAction(fieldName)),
        submitForm: (formData) => dispatch(submitFormAction(formData))
    };
}

const VisibleEnquiryForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(EnquiryForm);

export default VisibleEnquiryForm;
